<div class='row-fluid editor-add-template-wrapper'>
  <label for='template-area-title'>Enter text area title</label>
  <input id="template-title" name='template-area-title' class='build-input editor-add-template-title span12' style='display=block;' value="{{title}}" placeholder='Enter a Template Area Title'>

  <label for='template-area-description'>Enter text area description</label>
  <textarea  id="template-description-editor" name='template-area-description' class='build-textarea editor-add-template-description span12' style='display=block; height=60px;' placeholder='Enter a Template Area Description'>{{{description}}}</textarea>
  <div class='editor-buttons'>
    <button class='editor-add-template-delete delete'>Delete</button>
    <button class='editor-add-template-cancel cancel'>Cancel</button>
    <button class='editor-add-template-submit save'>Save</button>
  </div>
</div>
